import styled from 'styled-components';
import { colors } from '../../../../healtheraComponents';

export const StyledCustomLinksList = styled.div`
  margin: 20px 0;
`;

export const StyledCustomLinkContainer = styled.div`
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
  gap: 10px;
  background-color: ${colors.GRAY_LIGHTER};
  display: flex;
  align-items: center;
`;
